<template>
    <a-locale-provider :locale="locale">
        <div id="app">
            <!-- 路由出口 -->
            <!-- 路由匹配到的组件将渲染在这里 -->
            <router-view></router-view>
        </div>
    </a-locale-provider>
</template>
<script>
import Vue from "vue";
import VueRouter from "vue-router";

import { message } from "ant-design-vue";
Vue.prototype.$message = message;
Vue.use(VueRouter);



import "weui/dist/style/weui.min.css";

//import K1Home from "./components/back-end/k1_candidate.vue"
import K1Home from "./components/back-end/k1_result.vue"

const routes = [
    { path: "/", component: K1Home },
];

const router = new VueRouter({
    routes, // (缩写) 相当于 routes: routes
});
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
    name: "App",
    router: router,
    data() {
        return {
            locale: zhCN,
        };
    },
};
</script>